import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TicketListIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TicketListIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.46192 3.86035C4.79326 3.86035 2.62988 6.02373 2.62988 8.69239C2.62988 9.4661 3.07359 10.1712 3.7711 10.506L4.22446 10.7237C5.29519 11.2377 5.29519 12.7621 4.22446 13.2761L3.7711 13.4937C3.07359 13.8285 2.62988 14.5337 2.62988 15.3074C2.62988 17.9761 4.79326 20.1394 7.46192 20.1394H17.7979C20.4665 20.1394 22.6299 17.9761 22.6299 15.3074C22.6299 14.5337 22.1862 13.8285 21.4887 13.4937L21.0353 13.2761C19.9646 12.7621 19.9646 11.2377 21.0353 10.7237L21.4887 10.506C22.1862 10.1712 22.6299 9.4661 22.6299 8.69239C22.6299 6.02373 20.4665 3.86035 17.7979 3.86035H7.46192ZM4.02523 8.69239C4.02523 6.79436 5.56389 5.2557 7.46192 5.2557H17.7979C19.6958 5.2557 21.2345 6.79436 21.2345 8.69239C21.2345 8.92946 21.0985 9.14552 20.8849 9.24811L20.4315 9.46573C18.3054 10.4862 18.3054 13.5136 20.4315 14.534L20.8849 14.7517C21.0985 14.8542 21.2345 15.0703 21.2345 15.3074C21.2345 17.2054 19.6958 18.7441 17.7979 18.7441H7.46192C5.56389 18.7441 4.02523 17.2054 4.02523 15.3074C4.02523 15.0703 4.16119 14.8542 4.37491 14.7517L4.82827 14.534C6.95439 13.5136 6.95438 10.4862 4.82827 9.46573L4.37491 9.24811C4.16119 9.14552 4.02523 8.92946 4.02523 8.69239Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22446 13.2761C5.29519 12.7621 5.29519 11.2377 4.22446 10.7237L3.7711 10.506C3.07359 10.1712 2.62988 9.4661 2.62988 8.69239C2.62988 6.02373 4.79326 3.86035 7.46192 3.86035H17.7979C20.4665 3.86035 22.6299 6.02373 22.6299 8.69239C22.6299 9.4661 22.1862 10.1712 21.4887 10.506L21.0353 10.7237C19.9646 11.2377 19.9646 12.7621 21.0353 13.2761L21.4887 13.4937C22.1862 13.8285 22.6299 14.5337 22.6299 15.3074C22.6299 17.9761 20.4665 20.1394 17.7979 20.1394H7.46192C4.79326 20.1394 2.62988 17.9761 2.62988 15.3074C2.62988 14.5337 3.07359 13.8285 3.7711 13.4937L4.22446 13.2761ZM4.37491 14.7517C4.16119 14.8542 4.02523 15.0703 4.02523 15.3074C4.02523 17.2054 5.56389 18.7441 7.46192 18.7441H17.7979C19.6958 18.7441 21.2345 17.2054 21.2345 15.3074C21.2345 15.0703 21.0985 14.8542 20.8849 14.7517L20.4315 14.534C18.3054 13.5136 18.3054 10.4862 20.4315 9.46573L20.8849 9.24811C21.0985 9.14552 21.2345 8.92946 21.2345 8.69239C21.2345 6.79436 19.6958 5.2557 17.7979 5.2557H7.46192C5.56389 5.2557 4.02523 6.79436 4.02523 8.69239C4.02523 8.92946 4.16119 9.14552 4.37491 9.24811L4.82827 9.46573C6.95438 10.4862 6.95439 13.5136 4.82827 14.534L4.37491 14.7517ZM15.6532 11.3022H9.60671C9.22139 11.3022 8.90903 11.6146 8.90903 11.9999C8.90903 12.3852 9.22139 12.6976 9.60671 12.6976H15.6532C16.0385 12.6976 16.3509 12.3852 16.3509 11.9999C16.3509 11.6146 16.0385 11.3022 15.6532 11.3022Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TicketListIcon;
